/**
 * Types of errors that can occur when loading conversations
 */
export enum ConversationErrorType {
  /** API returned success: false */
  UNSUCCESSFUL = 'UNSUCCESSFUL',

  /** Network or API connection error */
  POSSIBLE_NETWORK_ERROR = 'POSSIBLE_NETWORK_ERROR',

  /** Unknown error occurred */
  UNKNOWN = 'UNKNOWN',
}

/**
 * Types of errors that can occur when sending messages
 */
export enum MessageSendErrorType {
  /** API returned success: false */
  UNSUCCESSFUL = 'UNSUCCESSFUL',

  /** Network or API connection error */
  POSSIBLE_NETWORK_ERROR = 'POSSIBLE_NETWORK_ERROR',

  /** Unknown error occurred */
  UNKNOWN = 'UNKNOWN',
}

/**
 * Conversation error object with type and message
 */
export interface ConversationError {
  type: ConversationErrorType;
  message: string;
}

/**
 * Message send error object with type and message
 */
export interface MessageSendError {
  type: MessageSendErrorType;
  message: string;
  recoveryMessage?: string;
}
